export default "__VITE_ASSET__e57b1e14__"